// extracted by mini-css-extract-plugin
export default {"mediumContainer":"Yp54oeKmKYC_NzeUOcB5"};